import { render, staticRenderFns } from "./ZDropdownClients.vue?vue&type=template&id=4de78a70&"
import script from "./ZDropdownClients.vue?vue&type=script&lang=js&"
export * from "./ZDropdownClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports